import emojiRegex from "emoji-regex"
import env from "@/common/env"

export const ios = () => navigator.userAgent.match(/ipad|ipod|iphone/i)
export const ie = () => navigator.userAgent.indexOf("MSIE ") >= 0 || navigator.userAgent.match(/Trident.*rv:11\./)
export const macOs = () => ["Macintosh", "MacIntel"].indexOf(window.navigator.platform) >= 0
export const iosVersion = (major: number, minor?: number) => {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    const version = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/) || []
    const parts = [parseInt(version[1], 10), parseInt(version[2], 10), parseInt(version[3] || "0", 10)]

    if (parts[0] >= major && (!minor || minor >= parts[1])) {
      return true
    }
  }

  return false
}

export const arrayUniq = <T>(array?: T[]): T[] => {
  if (!array) {
    return []
  }

  return array.filter((v, i, a) => a.indexOf(v) === i)
}

export const parentsInclude = (node: Node, ...nodeNames: string[]) => {
  let currentEl = node
  nodeNames = nodeNames.map(n => n.toLowerCase())

  if (nodeNames.includes(currentEl.nodeName.toLowerCase())) {
    return true
  }

  while (currentEl.parentNode) {
    currentEl = currentEl.parentNode

    if (nodeNames.includes(currentEl.nodeName.toLowerCase())) {
      return true
    }
  }

  return false
}

export const loadImage = (path: string, crossOrigin?: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = e => reject(e)

    if (crossOrigin && !ie()) {
      img.crossOrigin = crossOrigin
    }

    if (env.isJSDOM && path.startsWith("/image/get") && process.env["SM_IMAGE_HOST"]) {
      path = `${process.env["SM_IMAGE_HOST"]}${path}`
    }

    img.src = path
  })

const emojiRreplacement = emojiRegex()
export const stripEmoji = (text: string): string => {
  return text.replace(emojiRreplacement, "")
}

const replacement = /[\u2028|\u2029]/g
export const stripInvalid = (text: string): string => {
  return text.replace(replacement, "")
}

export const copyToClipboard = (str: string, input?: HTMLInputElement | null) => {
  const el = input || document.createElement("textarea")

  el.contentEditable = "true"
  el.readOnly = false
  el.value = str

  if (!input) {
    el.style.position = "absolute"
    el.style.left = "-9999px"
    document.body.appendChild(el)
  }

  if (ios()) {
    const range = document.createRange()
    range.selectNodeContents(el)
    const selection = window.getSelection()
    selection?.removeAllRanges()
    selection?.addRange(range)
    el.setSelectionRange(0, 999999)
  } else {
    el.select()
  }

  document.execCommand("copy")

  if (ios()) {
    el.setSelectionRange(0, 0)
    el.blur()
  }

  if (!input) {
    document.body.removeChild(el)
  }
}

// Remove empty objects inside object recursively
export const removeEmpty = (obj: any) => {
  Object.entries(obj).forEach(([key, val]) => {
    if (val && typeof val === "object" && Object.keys(val as Record<string, unknown>).length > 0) {
      removeEmpty(val)
    }

    if (val == null || Object.keys(val as Record<string, unknown>).length === 0) {
      delete obj[key]
    }
  })
}

export const promiseTimeout = (timeout: number) => {
  return new Promise(resolve => setTimeout(resolve, timeout))
}

export const matchArray = (arrayA?: any[] | null, arrayB?: any[] | null) => {
  if (!arrayA || !arrayB) {
    return false
  }

  arrayA = arrayA.filter((v, i, a) => a.indexOf(v) === i)
  arrayB = arrayB.filter((v, i, a) => a.indexOf(v) === i)

  // compare lengths - can save a lot of time
  if (arrayA.length !== arrayB.length) {
    return false
  }

  return arrayA.every(el => arrayB?.includes(el)) && arrayB.every(el => arrayA?.includes(el))
}

export const getLocation = (url: string): string => {
  const el = document.createElement("a")
  el.href = url
  return `${el.pathname}${el.search}`
}

export const defaultImageSize = (signHeight: number, signWidth: number, ratio: number) => {
  let height = signHeight * 0.7
  let width = height / ratio

  if (width > signWidth) {
    width = signWidth * 0.7
    height = width * ratio
  }
  return {
    width: width,
    height: height,
  }
}
